import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  PreReinvoicingChecks,
  PreReinvoicingChecksVariables,
} from '@/graphql/contracts/_generated_/isReinvoicingAReinvoicedPeriod.query';
import PreReinvoicingChecksQuery from '@/graphql/contracts/isReinvoicingAReinvoicedPeriod.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { PreReinvoicingChecksInputType } from '@/graphql/contracts/_generated_/contracts';

export default function usePreReinvoicingChecks() {
  const [_runChecks, { loading }] = useLazyQuery<
  PreReinvoicingChecks,
  PreReinvoicingChecksVariables
  >(PreReinvoicingChecksQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const runPreReinvoicingChecks = useCallback(
    async (input: PreReinvoicingChecksInputType) => {
      const response = await _runChecks({
        variables: { input },
      });

      return response.data?.preReinvoicingChecks ?? null;
    },
    [_runChecks]
  );

  return {
    runPreReinvoicingChecks,
    isLoadingPreReinvoicingChecks: loading,
  };
}
